
const units = {
  voltage: [100, "V"], batteryVoltage: [100, "V"],
  temperature: [1000, "°C"], oilTemperature: [1000, "°C"], externalTemperature: [1000, "°C"],
  batteryTemperature: [1000, "°C"], batteryControllerTemperature: [1000, "°C"],
  odometer: [1000, "km"], odometerRealTime: [1000, "km"], odometerTripA: [1000, "km"],
  odometerEco: [1000, "km"], odometerNormal: [1000, "km"], odometerPower: [1000, "km"],
  onTime: [60, "h"], onTimeFromDevice: [60, "h"], onTimeRealTime: [60, "h"],
  speed: [1, "km/h"], altitude: [1, "m"], bearing: [1, "°"],
  latitude: [1, "°"], longitude: [1, "°"], pressure: [1, "hPa"],
  tankLiters: [1, "L"], tankPercentage: [1, "%"], secondaryTankPercentage: [1, "%"],
  percentage: [1, "%"], batteryPercentage: [1, "%"], stateOfHealth: [1, "%"],
  oilQualityPercentage: [1, "%"], levelPercentage: [1, "%"],
  autonomy: [1, "km"], autonomyEco: [1, "km"], autonomyNormal: [1, "km"], autonomyPower: [1, "km"],
  kmToService: [1, "km"], kmToOilChange: [1, "km"], daysToService: [1, "dias"],
  checkEngineLightOnKm: [1, "km"], rpm: [1, "rpm"],
};

export function reading(twin, path) {
  const measure = path.split(".").reduce((value, key) => value && value[key], twin);
  return measure && typeof measure === "object" ? measure : { value: measure };
}

export function formatTimestamp(value) {
  if (value == null || value === "") return "-";
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date.toLocaleString("pt-PT", {
    timeZone: "Europe/Lisbon", day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }) : String(value);
}

function lisbonParts(date) {
  return Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Lisbon", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  }).formatToParts(date).filter((part) => part.type !== "literal").map((part) => [part.type, Number(part.value)]));
}

export function calendarDate(date = new Date()) {
  const parts = lisbonParts(date);
  return new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
}

// Calendar dates encode selected wall-clock fields in the browser's zone, not Lisbon's.
export function lisbonIso(date) {
  const wallTime = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  let instant = wallTime;
  for (let index = 0; index < 2; index++) {
    const parts = lisbonParts(new Date(instant));
    const displayed = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second, date.getMilliseconds());
    instant += wallTime - displayed;
  }
  const result = new Date(instant);
  const parts = lisbonParts(result);
  // Reject nonexistent Lisbon clock times during the spring DST change.
  return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second, date.getMilliseconds()) === wallTime
    ? result.toISOString() : null;
}

export function formatMetric(value, unit, maximumFractionDigits = 2) {
  if ((typeof value !== "number" && typeof value !== "string") || String(value).trim() === "" || !Number.isFinite(Number(value))) return "-";
  return `${Number(value).toLocaleString("pt-PT", { maximumFractionDigits })}${unit ? ` ${unit}` : ""}`;
}

export function formatReading(path, value) {
  if (value == null || value === "") return "-";
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) return formatTimestamp(value);
  const field = path.replace(/\.value$/, "").split(".").pop();
  let spec = units[field];
  if (/deviceDiagnostics\.temperatureSensors\.sensors\[\d+\](\.value)?$/.test(path)) spec = [1000, "°C"];
  if (/deviceDiagnostics\.inputs\.digitalInputs\[\d+\]\.counter(\.value)?$/.test(path)) spec = [3600, "h"];
  if (!spec) return typeof value === "number" && !["cellID", "mnc", "mcc", "lac", "index", "diagnosticsErrorMask", "obdErrorMask"].includes(field)
    ? formatMetric(value, "") : String(value);
  if ((typeof value !== "number" && typeof value !== "string") || String(value).trim() === "" || !Number.isFinite(Number(value))) return "-";
  return formatMetric(Number(value) / spec[0], spec[1], ["latitude", "longitude"].includes(field) ? 6 : spec[1] === "km" ? 3 : 2);
}

export function coordinates(value) {
  if (!value) return null;
  const lat = Array.isArray(value) ? value[0] : value.latitude;
  const lng = Array.isArray(value) ? value[1] : value.longitude;
  const valid = (number) => (typeof number === "number" || typeof number === "string" && number.trim() !== "") && Number.isFinite(Number(number));
  return valid(lat) && valid(lng) && Math.abs(Number(lat)) <= 90 && Math.abs(Number(lng)) <= 180
    ? [Number(lat), Number(lng)] : null;
}
